import { ADDITIONAL_HEIGHT, CARD_PADDING, COEFFICIENT_DIGITAL_HEIGHT, INITIAL_OFFSET } from 'components/widgets/Rail/constants';

import { Data, Item } from '../VirualizedContainer/types';

export type RenderCardItemProps<T extends Item> = {
  index: number;
  style: React.CSSProperties;
  data: Data<T>;
};

/**
 * Renders a single card item.
 *
 * @typeparam T - The type of the item to be rendered.
 * @param props - The properties passed to the component.
 * @returns The React element representing the card item.
 */
const VirtualizedCardItem = <T extends Item>({ index, style, data }: RenderCardItemProps<T>) => {
  const { children, items, imageHeight, imageWidth, hasAssetsMarkedByNumber } = data;
  const paddingTop = ADDITIONAL_HEIGHT - 10;
  const item = items[index];

  const additionStyles = hasAssetsMarkedByNumber ? {
    paddingLeft: Number(imageHeight) / COEFFICIENT_DIGITAL_HEIGHT - CARD_PADDING,
  } : undefined;

  return (
    <li
      key={item.id}
      style={{
        ...style,
        boxSizing: 'border-box',
        left: Number(style.left) + INITIAL_OFFSET,
        paddingRight: CARD_PADDING,
        paddingTop,
        ...additionStyles,
      }}
    >
      {children({
        imageHeight: imageHeight ?? 0,
        itemWidth: hasAssetsMarkedByNumber ?  Number(imageWidth) + CARD_PADDING : Number(style.width) - CARD_PADDING,
        item,
        index,
      })}
    </li>
  );
};

export default VirtualizedCardItem;
